export default {
  activeQuestionIndex: '0_0_0'
}
